import MmxApi from "../api/mmxApi";

export default {
  createUser: (payload, params, server, dispatch) => {
    const api = new MmxApi(server, null, dispatch);
    return api.user.createUser(payload, params);
  },

  getOrgSettings: (params, server, dispatch) => {
    const api = new MmxApi(server, null, dispatch);
    return api.user.getOrgSettings(params);
  },
};






// WEBPACK FOOTER //
// ./src/services/registrationService.js